
namespace GeniuzPOS.AdvPromo {

    @Serenity.Decorators.registerClass()
    export class PsAdvPromoItem5ExemptGrid extends Serenity.EntityGrid<PsAdvPromoItem5ExemptRow, any> {
        protected getColumnsKey() { return PsAdvPromoItem5ExemptColumns.columnsKey; }
        protected getDialogType() { return PsAdvPromoItem5ExemptDialog; }
        protected getIdProperty() { return PsAdvPromoItem5ExemptRow.idProperty; }
        protected getInsertPermission() { return PsAdvPromoItem5ExemptRow.insertPermission; }
        protected getLocalTextPrefix() { return PsAdvPromoItem5ExemptRow.localTextPrefix; }
        protected getService() { return PsAdvPromoItem5ExemptService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}